const searchParams = new URLSearchParams(window.location.search);
const hashParams = new URLSearchParams(window.location.hash ? window.location.hash.substring(1) : "");

/**
 * @private
 * @param {string} feature
 * @param  {boolean} [defaultValue]
 * @return {boolean}
 */
const isEnabled_ = (feature, defaultValue = false) => {
  const value =
      searchParams.get(feature) ||
      hashParams.get(feature);
  if (value) {
    if (value === 'false' || value === '0') {
      return false;
    } else if (value === 'true' || value === '1') {
      return true;
    } else {
      return defaultValue;
    }
  } else {
    const hasParam = searchParams.has(feature) || hashParams.has(feature);
    return hasParam ? true : defaultValue;
  }
};

/**
 * @return {boolean}
 */
export const declutterRouteLogo = () => {
  return isEnabled_('declutterRouteLogo');
};


/**
 * If enabled, use jQuery ui Datepicker instead of native <input type="date">.
 * By default, the native date input is used if the browser supports it.
 * @return {boolean}
 */
export const noNativeDateInput = () => {
  return isEnabled_('noNativeDateInput');
};

/**
 * If enabled shows 'Snap to network' button in track edit menu
 * @return {boolean}
 */
export const snapToNetwork = () => {
  return isEnabled_('snapToNetwork');
};

